import { ErrorBoundary } from 'react-error-boundary';
import { Routes, Route } from 'react-router-dom';

import { AccessControl } from '../../../components';
import { VmsConfigAction, useVmsAccessControl } from '../../../hooks/useVmsAccessControl';
import ErrorLogger from '../../../providers/ErrorLogger';
import RouteGuard from '../../../routes/RouteGuard';
import VmsListing from '../listing';

export const VmsRoutes = () => {
  const { access, owns } = useVmsAccessControl([
    VmsConfigAction.VIEW_VMS_CONFIGURATION,
    VmsConfigAction.EDIT_VMS_CONFIGURATION,
    VmsConfigAction.DELETE_VMS_CONFIGURATION,
  ]);
  const hasAccess = owns || access[0] || access[1] || access[2];
  return (
    <Routes>
      <Route
        path="/"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              {hasAccess ? <VmsListing /> : <AccessControl />}
            </ErrorBoundary>
          </RouteGuard>
        }
      />
    </Routes>
  );
};
